// apps/client/src/game/interactions/shell.ts (M1-T15) — A picks up the nearest of your personal shells in front, within reach.
import { tuning } from '@whiskerton/content';
import type { Interaction } from '../interact';
import { useGame } from '../../state/store';
import { fishingLayerOf } from '../../world/fishing';

const FRONT_COS = 0.2;

export const interaction: Interaction = {
  id: 'shell',
  find(ctx) {
    const you = ctx.store.you;
    if (ctx.space !== 'out' || !you) return null;
    const fx = Math.sin(ctx.f), fy = Math.cos(ctx.f);
    let best: { id: string; d: number; x: number; y: number } | null = null;
    for (const s of you.yields.shells) {
      const dx = s.x - ctx.pos.x, dy = s.y - ctx.pos.y, d = Math.hypot(dx, dy);
      if (d > tuning.town.interactRange || (d > 0.6 && (dx * fx + dy * fy) / d < FRONT_COS)) continue;
      if (!best || d < best.d) best = { id: s.id, d, x: s.x, y: s.y };
    }
    return best && { id: best.id, at: { x: best.x, y: best.y }, verb: 'hud.verbPickUp', priority: 52 };
  },
  run(ctx, c) {
    const game = ctx.game, shell = c.id;
    game.you()?.avatar.play('pickUp');
    void game.cmd.act('shell.pickUp', { shell }, {
      optimistic: () => {
        fishingLayerOf(game)?.removeShell(shell);
        return () => { const you = useGame.getState().you; if (you) void fishingLayerOf(game)?.setShells(you.yields.shells); };
      },
    }).then((res) => { if (res.ok) game.sound.sfx('pickUp'); });
  },
};
